/* global Raven */

/**
 * This is the setup file for Sentry, the frontend error logger we're using.
 * For some reason it calls itself Raven.
 */

/************
 * SETTINGS *
 ************/

AoPS.ErrorUtil = {
	PRODUCTION_ONLY: true, // only log to Sentry in production
	IGNORE_ERRORS: [
		// String/Regex error messages to ignore.
		// This list comes from: https://docs.sentry.io/clients/javascript/tips/?platform=javascript
		"top.GLOBALS",
		"originalCreateNotification",
		"canvas.contentDocument",
		"MyApp_RemoveAllHighlights",
		"http://tt.epicplay.com",
		"Can't find variable: ZiteReader",
		"jigsaw is not defined",
		"ComboSearch is not defined",
		"http://loading.retry.widdit.com/",
		"atomicFindClose",
		"fb_xd_fragment",
		"bmi_SafeAddOnload",
		"EBCallBackMessageReceived",
		"conduitPage",
		// Bing being whack
		/\bUET\b/,
		// Raven being whack
		/\(raven\)/i,
		// MathJax being whack
		"Cannot read property 'offsetParent' of null",
		"Cannot read property 'DOMNodeInsertedByJs' of undefined",
		// Safari Webview... more like Safari Bugview
		"SymBrowser_Modify",
		"Can't find variable: __opera",
		"Can't find variable: didEnterViewPort",
		"Can't find variable: GetHTMLElementsAtPoint",
		"Can't find variable: GetImageTagSrcFromPoint",
		"Can't find variable: require",
		"Can't find variable: MyAppGetLinkTitleNameAtPoint",
		"Can't find variable: MyAppGetLinkSRCAtPoint",
		"Can't find variable: MyAppGetLinkHREFAtPoint",
		"Can't find variable: MyAppGetHTMLElementsAtPoint",
		"Can't find variable: UC_NEWS_PAUSE_ALL_VIDEOS",
		"document.getElementsByTagName('video')[0].webkitExitFullScreen",
		'document.getElementsByName("screen-orientation")[0].content',
		'document.getElementsByName("full-screen")',
		"window.biliInject.postMessage", // what is this heckin spooky mystery
		"undefined is not an object (evaluating 'window.webkit.messageHandlers')",
		"Invalid character: '\\0'",
		"Can't find variable: removeAllHighlights",
		/ss_post_message_to_iframe_injection/i,
		// Chinese browsers/extensions
		"$UCBrowser",
		"WeixinJSBridge",
		"__tb_js_bridge",
		"ZhihuiOS",
		"x5onSkinSwitch is not defined",
		/ServerLocationCb\d+ is not defined/,
		"Cannot read property 'content' of undefined",
		"hwbrNotifyScreenConfigChanged is not defined.",
		// Browser or extension bugs
		"Cannot redefine property: BetterJsPop", // ad blocker
		"__gCrWeb.form.wasEditedByUser.set",
		"vid_mate_check",
		"__firefox__",
		"Cannot redefine property: googletag",
		"w2zo.data.indexOf",
		"extAbbr is not defined",
		/Invalid regular expression: \/function\(/i,
		"Access is denied.", // Stupid Edge bug.
		"a.LegacyGlobal.LP_explicit_ignored", // LastPass bug
		/Permission denied to access property/i, // Firefox security feature
		"ResizeObserver loop limit exceeded", // Benign Chrome warning
		// Mac OSX Safari
		"Argument 1 ('target') to MutationObserver.observe must be an instance of Node",
		// Chrome Android
		"Cannot read property 'checkDomStatus' of undefined",
		"document.getElementsByClassName.ToString is not a function", // Samsung device bug.
		"Cannot read property 'updateBookMallStatus' of undefined", // 3rd party code
		// Some app called Pocket
		"Can't find variable: pktAnnotationHighlighter",
		// Probably a vendor script being goofy
		"Failed to execute 'postMessage' on 'Window': function (",
		"Unspecified error.",
		// Odd Firefox/iOS bug that doesn't seem to do anything.
		"null is not an object (evaluating 'a.title')",
		"Failed to read the 'cookie' property from 'Document': Access is denied for this document.", // cookies disabled on mobile
		/Failed to load 'https:\/\/.+\.ru\/adb_rotate\?/i, // Russian proxy site?
		/www\.clickcease\.com/i, // third party marketing analytics
		/monitor\.clickcease\.com/i, // third party marketing analytics
		"TypeError: Load failed", // webkit bug https://stackoverflow.com/a/74475080
		"The script at 'https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/worker-yaml.js' failed to load.", // cloudflare load issue
	],
	IGNORE_URLS: [
		// Matches regex or exact string. URLs to ignore errors from.
		/graph\.facebook\.com/i,
		/connect\.facebook\.net\//i,
		/eatdifferent\.com\.woopra-ns\.com/i,
		/static\.woopra\.com\/js\/woopra\.js/i,
		/extensions\//i,
		/^chrome:\/\//i,
		/^chrome-extension:\/\//i,
		/127\.0\.0\.1:4001\/isrunning/i,
		/webappstoolbarba\.texthelp\.com\//i,
		/metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
	],
	// A map of file names that are critical dependencies.
	// If an error originates from one of these files, their vital function
	// will be performed. If the function is true, then
	// AoPS.ErrorUtil.criticalFailure will become true, and an error will be logged.
	// An error will also be logged if one of these files fails to load.
	vitals: {
		"/js/jquery.min.js": function () {
			return typeof $ === "undefined";
		},
		"/vendor/common-combined-2.js": function () {
			return (
				typeof Backbone === "undefined" ||
				typeof _ === "undefined" ||
				typeof Handlebars === "undefined"
			);
		},
	},
	consoleErrors: true, // whether to show errors in console
	consoleSentryObjects: false, // whether to show objects sent to Sentry in the console
	blockSentry: false, // whether to cancel logs to Sentry right before they get sent
	criticalFailure: false, // whether any of the conditions in this.vitals has failed during a relevant ErrorEvent.
	scriptLoadError: false, // whether a script tag on this page failed to load
	mFolder: null, // the mFolder of this page
};

/*************
 * FUNCTIONS *
 *************/

/**
 * Initialization stuff.
 */
AoPS.ErrorUtil._init = function () {
	this.mFolder = this._getMFolder();

	if (this._canCloudLog(false)) {
		// Check if we can use Sentry/Raven in this environment.
		// Build the Sentry/Raven config.
		var config = {};
		var self = this;
		config.release = AoPS.sentry.assetVersion; // Associate errors with release numbers.
		config.environment =
			AoPS.repo === "acad"
				? AoPS.sentry.acadEnvironment
				: AoPS.sentry.aopsEnvironment; // Attach environment information to errors
		config.ignoreErrors = AoPS.ErrorUtil.IGNORE_ERRORS;
		config.ignoreUrls = AoPS.ErrorUtil.IGNORE_URLS;

		// Transform data before verifying.
		config.dataCallback = function (data) {
			Raven.setTagsContext({
				scriptLoadError: self.scriptLoadError,
				mFolder: self.mFolder,
			}); // Update tags.
			Raven.setExtraContext(); // Clear extra data from the context.

			// If this transaction is a critical failure, add that to the tags.
			if (data.transaction) {
				if (!data.tags) {
					data.tags = {
						scriptLoadError: self.scriptLoadError,
						mFolder: self.mFolder,
					};
				}
				var critical = self._checkVitals(data.transaction);
				if (critical) {
					data.tags.type = "E_CRITICAL_DEPENDENCY_FAILURE";
				}
			}
			return data;
		};

		// Verify data before sending.
		config.shouldSendCallback = function (data) {
			var send = true;

			if (self.criticalFailure) {
				send = false;
				if (self.consoleSentryObjects) {
					console.log("Error log cancelled by ErrorUtil.criticalFailure");
				}
			} else if (
				data.tags &&
				data.tags.type === "E_CRITICAL_DEPENDENCY_FAILURE"
			) {
				self.criticalFailure = true;
			} else if (self.scriptLoadError) {
				send = false;
				console.log("Error log cancelled by ErrorUtil.scriptLoadError");
			}

			if (send && self.blockSentry) {
				send = false;
				if (self.consoleSentryObjects) {
					console.log("Error log cancelled by ErrorUtil.blockSentry");
				}
			}

			if (self.consoleSentryObjects) {
				console.log(send ? "Sending: " : "Not sending: ", data);
			}

			return send;
		};

		// Setup Raven.
		Raven.config(
			AoPS.repo === "acad"
				? "https://1a1e07bb9c0b4ea982520ea420a8d5ce@sentry.io/1294162"
				: "https://6b4d51ae86274a829b38a3d93186b59a@sentry.io/1285919",
			config
		).install();

		// Attach AoPS user data to the error context.
		if (AoPS.session && AoPS.session.logged_in) {
			Raven.setUserContext({
				id: AoPS.session.user_id,
				platform_user_id: AoPS.session.platform_user_id,
				username: AoPS.session.username,
			});
		}

		this._listenFailingScripts();
	}
};

/**
 * Returns whether ErrorUtil can cloud log errors.
 * Will return false when things like jquery fail to load (see epic_fail.js).
 * Will return false in non-production environments if PRODUCTION_ONLY is true.
 * Will return false if Raven is missing or not set up.
 * Will return false if this.criticalFailure.
 * @param {boolean} [checkRaven] Check if Raven is set up. Default true.
 * @returns {boolean} Whether ErrorUtil can cloud log errors.
 */
AoPS.ErrorUtil._canCloudLog = function (checkRaven) {
	if (this.criticalFailure) {
		return false;
	}

	checkRaven = checkRaven === undefined ? true : checkRaven;
	if (
		(AoPS.repo === "acad"
			? AoPS.sentry.acadEnvironment
			: AoPS.sentry.aopsEnvironment) === "production" ||
		!this.PRODUCTION_ONLY
	) {
		if (checkRaven) {
			if (Raven && Raven.isSetup()) {
				return true;
			}
			return false;
		}
		return true;
	}
	return false;
};

/**
 * Returns the first segment of the URL pathname,
 * usually the name of the mFolder.
 *
 * @returns {String} The first segment of the URL pathname.
 */
// Workaround for eslint-plugin-react 7.30.0
// eslint-disable-next-line react/display-name
AoPS.ErrorUtil._getMFolder = function () {
	var pathname = window.location.pathname;
	var match = pathname.match(/\/([^/]+)\/?/);
	if (match) {
		return match[1];
	}
	return null;
};

/**
 * Logs an input with console.error if available, otherwise falls back to console.log.
 * @param {*} obj The thing you want to log.
 */
AoPS.ErrorUtil._consoleError = function (obj) {
	if (console.error) {
		console.error(obj);
	} else {
		console.log(obj);
	}
};

/**
 * Attaches a capturing listener to the window for load errors.
 * If a script doesn't load which is considered vital,
 * then we log it and turn off future error logging.
 */
AoPS.ErrorUtil._listenFailingScripts = function () {
	var self = this;
	window.addEventListener(
		"error",
		function (e) {
			// Listen for HTTP errors on script elements.
			if (e.target && isScriptTag(e.target)) {
				self.scriptLoadError = true;
				// Log if the missing file is vital.
				if (self._isVital(e.target.src)) {
					self.log(
						"E_CRITICAL_DEPENDENCY_FAILURE",
						"<script> failed to load file " + e.target.src,
						{src: e.target.src}
					);
				} else {
					// Otherwise make it a breadcrumb.
					self.breadcrumb(
						"<script> failed to load file " + e.target.src,
						"script",
						"warning",
						{src: e.target.src}
					);
				}
			}
		},
		true
	);

	function isScriptTag(target) {
		return (
			target && target.tagName && target.tagName.toLowerCase() === "script"
		);
	}
};

/**
 * Expects a filename from an Error.
 * If the missing file is a critical dependency and has a key
 * in this.vitals, this function returns true.
 *
 * @param {string} missingFile
 * @returns {boolean} true if the file is a critical dependency
 */
AoPS.ErrorUtil._isVital = function (missingFile) {
	if (typeof missingFile === "string") {
		for (var file in this.vitals) {
			if (missingFile.indexOf(file) > -1) {
				return true;
			}
		}
	}
	return false;
};

/**
 * Expects a filename from an Error/ErrorEvent.
 * If there is a vital check associated with that file, then
 * it will be performed. If the check returns true, then a
 * critical dependency failure has occurred.
 *
 * @param {string} filename
 * @returns {boolean} true if a critical dependency failure occurred
 */
AoPS.ErrorUtil._checkVitals = function (filename) {
	if (typeof filename === "string") {
		for (var file in this.vitals) {
			if (filename.indexOf(file) > -1) {
				if (this.vitals[file]()) {
					return true;
				}
			}
		}
	}
	return false;
};

/**
 * Logs an error. AoPS user data will automatically be attached to the error.
 *
 * @param {string} type An error type such as "E_INVALID_FIELD".
 * @param {string|Error} message A string or Error object.
 * @param {object} [data] An object containing error-related data.
 */
AoPS.ErrorUtil.log = function (type, message, data) {
	if (this._canCloudLog()) {
		Raven.setTagsContext(); // Clear tags from the context.
		Raven.setExtraContext(); // Clear extra data from the context.

		if (type && typeof type === "string") {
			Raven.setTagsContext({
				scriptLoadError: this.scriptLoadError,
				mFolder: this.mFolder,
				type: type,
			}); // Update tags.
		}
		if (data && typeof data === "object") {
			Raven.setExtraContext(data); // Add data to the context.
		}
		if (message instanceof Error) {
			Raven.captureException(message); // Allow for message to be an exception.
		} else if (typeof message === "string") {
			Raven.captureException(new Error(message)); // Allow for message to be a string.
		}
	}
	if (this.consoleErrors) {
		// Log errors that would otherwise disappear.
		this._consoleError({
			type: type,
			message: message,
			data: data,
		});
	}
};

/**
 * Logs a breadcrumb.
 * Breadcrumbs are browser and application lifecycle events that are helpful in understanding
 * the state of the application leading up to a crash or error.
 *
 * @param {string} message A string describing the event. (e.g. "Added to cart.")
 * @param {string} category A category to label the event under. (e.g. "store")
 * @param {string} level May be "error", "warning", "info", or "debug".
 * @param {object} [data] A metadata object around the event.
 */
AoPS.ErrorUtil.breadcrumb = function (message, category, level, data) {
	if (Raven && Raven.isSetup()) {
		var breadcrumb = {};

		if (typeof message !== "string") {
			throw new Error("'message' must be a string.");
		}

		if (typeof category !== "string") {
			throw new Error("'category' must be a string.");
		}

		if (!level.match(/^(error|warning|info|debug)$/)) {
			throw new Error(
				"'level' must be 'error', 'warning', 'info', or 'debug'."
			);
		}

		if (data) {
			if (typeof data !== "object") {
				throw new Error("'data' must be an object.");
			} else {
				breadcrumb.data = data;
			}
		}

		breadcrumb.message = message;
		breadcrumb.category = category;
		breadcrumb.level = level;
		Raven.captureBreadcrumb(breadcrumb);
	}
	if (
		(AoPS.repo === "acad"
			? AoPS.sentry.acadEnvironment
			: AoPS.sentry.aopsEnvironment) === "development"
	) {
		// Log breadcrumbs that would otherwise disappear.
		console.log({
			message: message,
			category: category,
			level: level,
			data: data,
		});
	}
};

// Run init.
try {
	// Raven requires basic ES5. If we don't even have that, it can't properly
	// start up. And our site breaks. So skip everything.
	if (typeof Function.prototype.bind !== "undefined") {
		AoPS.ErrorUtil._init();
	}
} catch (e) {
	// ErrorUtil will fail gracefully and dump errors to console
	// if permitted by `consoleErrors`
	AoPS.ErrorUtil.log("E_ERRORUTIL_INIT_FAILURE", e);
}
